import {
  BlockAttachmentModel,
  BlockVarAttachmentModel
} from 'shared/models/blockAttachments';
import {
  AttachmentKind,
  BlockAttachmentServer,
  BlockVarAttachmentServer
} from 'shared/entities/file/server';

export const isFileAttachmentModel = (
  item: unknown
): item is BlockAttachmentModel => {
  return (
    typeof item === 'object' &&
    item !== null &&
    'kind' in item &&
    item.kind === AttachmentKind.attach
  );
};

export const isVarAttachmentModel = (
  item: unknown
): item is BlockVarAttachmentModel => {
  return (
    typeof item === 'object' &&
    item !== null &&
    'kind' in item &&
    item.kind === AttachmentKind.expr
  );
};

export const isFileAttachmentServer = (
  item: unknown
): item is BlockAttachmentServer => {
  return (
    typeof item === 'object' &&
    item !== null &&
    'kind' in item &&
    item.kind === AttachmentKind.attach
  );
};

export const isVarAttachmentServer = (
  item: unknown
): item is BlockVarAttachmentServer => {
  return (
    typeof item === 'object' &&
    item !== null &&
    'kind' in item &&
    item.kind === AttachmentKind.expr
  );
};
